import { toast } from 'sonner';

export default function handleErrors({ error }) {
    try {
        console.log(error)
        if (!navigator.onLine) {
            toast.error('Network Error - You seem to be offline. Please recheck your internet connection!');
        }
        else if (error.response.status === 0) {
            toast.error('Server Error - We are facing some problem with our server. Kindly redo this operation after some time. Aplogies for any inconveniences');
        }
        else if (error.response.data.errorMessage && typeof error.response.data.errorMessage === 'string') {
            toast.error(`Error: ${error.response.data.errorMessage}`)
        }
        else if (error && typeof error === 'string') {
            toast.error(`Error: ${error}`)
        }
        else {
            toast.error("We are currently experiencing technical difficulties with our servers. Please try again later. If the problem persists, please contact our team who would be happy to help")
        }
        return;
    } catch (err) {
        toast.error("We are currently experiencing technical difficulties with our servers. Please try again later. If the problem persists, please contact our team who would be happy to help")
    }
}